/**
 * @generated SignedSource<<343363d2bf277a0484adee2737ea173d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InterruptAgentInput = {
  llmConversationId: any;
  llmInteractionId: any;
};
export type useInterruptAgentMutationInterruptAgentMutation$variables = {
  input: InterruptAgentInput;
};
export type useInterruptAgentMutationInterruptAgentMutation$data = {
  readonly interruptAgent: {
    readonly success: boolean;
  };
};
export type useInterruptAgentMutationInterruptAgentMutation = {
  response: useInterruptAgentMutationInterruptAgentMutation$data;
  variables: useInterruptAgentMutationInterruptAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InterruptAgentPayload",
    "kind": "LinkedField",
    "name": "interruptAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useInterruptAgentMutationInterruptAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInterruptAgentMutationInterruptAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1ba49f7a94460b09a754093fbf524b7",
    "id": null,
    "metadata": {},
    "name": "useInterruptAgentMutationInterruptAgentMutation",
    "operationKind": "mutation",
    "text": "mutation useInterruptAgentMutationInterruptAgentMutation(\n  $input: InterruptAgentInput!\n) {\n  interruptAgent(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec3788a2c466845d28f127d159e29b43";

export default node;
